import { BoxShadowProps, variant } from 'styled-system';
import styled from '../../../theme/theme';
import { BorderProps, PropsWithPseudo } from '../../../theme/styledProps';

export type FormVariant = 'success' | 'warning' | 'error';

export type TextareaResize = 'horizontal' | 'vertical' | 'both' | 'none';

interface StyledTextareaProps {
  formVariant?: FormVariant;
  resize: TextareaResize;
}

export const StyledTextarea = styled.textarea<StyledTextareaProps>(
  ({ theme, resize }) => ({
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSizes.body,
    lineHeight: theme.lineHeights.body,
    display: 'flex',
    width: '100%',
    resize,
    position: 'relative',
    outline: 'none',
    appearance: 'none',
    padding: 8,
    borderRadius: theme.radii.medium,
    borderWidth: '1px',
    borderColor: theme.colors.neutral['300'],
    borderStyle: 'solid',
    backgroundColor: theme.colors.bg,
    color: theme.colors.neutral['700'],
    boxShadow: theme.shadows['200'],
    boxSizing: 'border-box',
    transition: `border-color ${theme.transitions.normal}, box-shadow ${theme.transitions.normal}`,

    '&:hover': {
      borderColor: theme.colors.neutral['400'],
      boxShadow: theme.shadows['300'],
    },

    '&:focus': {
      boxShadow: `0 0 0 2px ${theme.colors.primary['300']}`,
      borderColor: theme.colors.primary['500'],
    },

    '&:disabled': {
      color: theme.colors.neutral['500'],
      background: theme.colors.neutral['100'],
      borderColor: theme.colors.neutral['300'],
      pointerEvents: 'none',
    },

    '&::placeholder': {
      color: theme.colors.neutral['400'],
    },
  }),

  ({ theme }) =>
    variant<PropsWithPseudo<BorderProps & BoxShadowProps, '&:focus'>, FormVariant>({
      prop: 'formVariant',
      variants: {
        success: {
          borderColor: 'success.600',

          '&:focus': {
            boxShadow: `0 0 0 2px ${theme.colors.success['300']}`,
            borderColor: 'success.600',
          },
        },

        warning: {},

        error: {
          borderColor: 'error.500',

          '&:focus': {
            boxShadow: `0 0 0 2px ${theme.colors.error['200']}`,
            borderColor: 'error.500',
          },
        },
      },
    }),
);
